// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: inline-block;
  height: 17px;
  width: 17px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tag/tag.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;AACF","sourcesContent":[".row {\n  display: inline-block;\n  height: 17px;\n  width: 17px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
